import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { destroyPulseWidget, wasDockOpened } from './pulseLoader'
import { hopTimusActions } from './hopTimusSagas'

// The backend call is best-effort: destroyPulseWidget() already purged the local state.
const useHopTimusLogout = () => {
  const dispatch = useDispatch()

  return useCallback(() => {
    const docked = wasDockOpened()
    destroyPulseWidget()

    if (!window.Pulse && !docked) return

    dispatch({ type: hopTimusActions.END_SESSION })
  }, [dispatch])
}

export default useHopTimusLogout
